"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.SLC_CLASSIC_PAYMENT_SCHEDULE_CONTENT = exports.SLC_PAYMENT_SCHEDULE_CONTENT = void 0;
exports.SLC_PAYMENT_SCHEDULE_CONTENT = {
    SP_DISABLED_DEPOSIT_TITLE: 'First time using Flex',
    RECURRING_TITLE: 'Each month'
};
exports.SLC_CLASSIC_PAYMENT_SCHEDULE_CONTENT = __assign(__assign({}, exports.SLC_PAYMENT_SCHEDULE_CONTENT), { RECURRING_TITLE: 'Repeats month to month' });
